enum AiImageModel {
    DALLE_2 = 'dalle_2',
    DALLE_3 = 'dalle_3',
}

export default AiImageModel;
